import * as React from "react";
const SvgFile = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M4.49935 13.1667H9.49935M4.49935 9.83333H9.49935M4.49935 6.5H5.33268M7.83268 1.5H5.16602C3.76589 1.5 3.06582 1.5 2.53104 1.77248C2.06063 2.01217 1.67818 2.39462 1.4385 2.86502C1.16602 3.3998 1.16602 4.09987 1.16602 5.5V12.5C1.16602 13.9001 1.16602 14.6002 1.4385 15.135C1.67818 15.6054 2.06063 15.9878 2.53104 16.2275C3.06582 16.5 3.76588 16.5 5.16602 16.5H8.83268C10.2328 16.5 10.9329 16.5 11.4677 16.2275C11.9381 15.9878 12.3205 15.6054 12.5602 15.135C12.8327 14.6002 12.8327 13.9001 12.8327 12.5V6.5M7.83268 1.5L12.8327 6.5M7.83268 1.5V3.83333C7.83268 4.76675 7.83268 5.23346 8.01434 5.58998C8.17413 5.90359 8.4291 6.15856 8.7427 6.31834C9.09922 6.5 9.56593 6.5 10.4994 6.5H12.8327",
      stroke: "#004B9F",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgFile;
